
    
<app-bread-crumb 
    [Locations]="[{target : 'home', label : 'Home'}, {target : '/whatIsBeachwatch', label : 'About Beachwatch'}]"
    current="Subscribe">
</app-bread-crumb>

<div class="nsw-container">

    <div class="nsw-layout">
        <main class="nsw-layout__main">
            <div class="nsw-block">
                <h1 [tabindex]="0">Subscribe</h1>
                <h2 [tabindex]="0">Sign up to stay informed</h2>
                <p class="nsw-intro" [tabindex]="0">
                    Beachwatch issue daily pollution forecasts for many popular swimming locations in New South Wales. We'll send an email every morning to help you decide if it's safe to swim.
                    <br/>
                    <br/>
                    Please use the form below to subscribe to daily emails.                
                </p>
            </div>
            <div class="nsw-form" >
                <form [formGroup]="userSubscriptionsForm" class="subscribe-form">
                    <div class="nsw-form__group">
                        <label class="nsw-form__label nsw-form__required" for="firstName">First Name<span class="sr-only"> (required)</span></label>
                        <input class="nsw-form__input" type="text" id="firstName" name="firstName" [attr.aria-invalid]="firstName?.dirty && !firstName?.valid"  formControlName="firstName" required>
                        <span *ngIf="firstName?.touched && firstName?.hasError('required')" class="nsw-form__helper nsw-form__helper--error nsw-error-msg-wrapper" id="firstName-required-error-text">
                            <span class="material-icons nsw-material-icons" focusable="false" aria-hidden="true">cancel</span>
                            This field is required
                        </span>
                        <span *ngIf="firstName?.dirty && firstName?.hasError('minlength')" class="nsw-form__helper nsw-form__helper--error nsw-error-msg-wrapper" id="firstName-minlength-error-text">
                            <span class="material-icons nsw-material-icons" focusable="false" aria-hidden="true">cancel</span>
                            The minimum length for this field is {{firstName?.errors?.["minlength"]?.requiredLength}} characters.
                        </span>                        
                        <span *ngIf="firstName?.dirty && firstName.hasError('maxlength')" class="nsw-form__helper nsw-form__helper--error nsw-error-msg-wrapper" id="firstName-maxlength-error-text">
                            <span class="material-icons nsw-material-icons" focusable="false" aria-hidden="true">cancel</span>
                            The maximum length for this field is {{firstName?.errors?.["maxlength"]?.requiredLength}} characters.
                        </span> 
                        <span *ngIf="firstName?.dirty && firstName.hasError('pattern')" class="nsw-form__helper nsw-form__helper--error nsw-error-msg-wrapper" id="firstName-maxlength-error-text">
                            <span class="material-icons nsw-material-icons" focusable="false" aria-hidden="true">cancel</span>
                            First name must start with an alphabet.
                        </span> 
                        <span *ngIf="firstName?.dirty && firstName?.valid" class="nsw-form__helper nsw-form__helper--valid nsw-error-msg-wrapper" id="firstName-valid-text">
                            <span class="material-icons nsw-material-icons" focusable="false" aria-hidden="true">check_circle</span>
                            This field has been validated
                        </span>                                            
                    </div>

                    <div class="nsw-form__group">
                        <label class="nsw-form__label" for="lastName">Last Name</label>
                        <input class="nsw-form__input" type="text" id="lastName" name="lastName" [attr.aria-invalid]="lastName?.dirty && !lastName?.valid" formControlName="lastName">
                        <span *ngIf="lastName?.dirty && lastName?.hasError('minlength')" class="nsw-form__helper nsw-form__helper--error nsw-error-msg-wrapper" id="lastName-minlength-error-text">
                            <span class="material-icons nsw-material-icons" focusable="false" aria-hidden="true">cancel</span>
                            The minimum length for this field is {{lastName?.errors?.["minlength"]?.requiredLength}} characters.
                        </span>                        
                        <span *ngIf="lastName?.dirty && lastName?.hasError('maxlength')" class="nsw-form__helper nsw-form__helper--error nsw-error-msg-wrapper" id="lastName-maxlength-error-text">
                            <span class="material-icons nsw-material-icons" focusable="false" aria-hidden="true">cancel</span>
                            The maximum length for this field is {{lastName?.errors?.["maxlength"]?.requiredLength}} characters.
                        </span>
                        <span *ngIf="lastName?.dirty && lastName?.valid" class="nsw-form__helper nsw-form__helper--valid nsw-error-msg-wrapper" id="lastname-valid-text">
                            <span class="material-icons nsw-material-icons" focusable="false" aria-hidden="true">check_circle</span>
                            This field has been validated
                        </span> 
                    </div>

                    <div class="nsw-form__group">
                        <label class="nsw-form__label nsw-form__required" for="email">Email<span class="sr-only"> (required)</span></label>
                        <input class="nsw-form__input" type="text" id="email" name="email"  [attr.aria-invalid]="email?.dirty && !email?.valid"   formControlName="email" required>
                        <span *ngIf="email?.touched && email?.hasError('required')" class="nsw-form__helper nsw-form__helper--error nsw-error-msg-wrapper" id="email-required-error-text">
                            <span class="material-icons nsw-material-icons" focusable="false" aria-hidden="true">cancel</span>
                            This field is required                        
                        </span>
                        <span *ngIf="email?.dirty && email?.hasError('email')" class="nsw-form__helper nsw-form__helper--error nsw-error-msg-wrapper" id="email-format-error-text">
                            <span class="material-icons nsw-material-icons" focusable="false" aria-hidden="true">cancel</span>
                            Enter a valid email address.                        
                        </span>
                        <span *ngIf="email?.dirty && email?.valid" class="nsw-form__helper nsw-form__helper--valid nsw-error-msg-wrapper" id="email-valid-text">
                            <span class="material-icons nsw-material-icons" focusable="false" aria-hidden="true">check_circle</span>
                            This field has been validated
                        </span> 
                    </div>


                    <div class="nsw-block" > 
                        <p class="nsw-form__legend" [tabindex]="0">
                            When would you like to receive pollution forecast emails?
                            <br/>
                            [Need to check at least one option]                               
                        </p>    
                    </div>
                    <div class="nsw-form__group">
                        <fieldset class="nsw-form__fieldset">                           
                            <input 
                                class="nsw-form__radio-input" 
                                type="radio" 
                                id="updateFrequency0" 
                                name="updateFrequency" 
                                [value]="UPDATE_FREQUENCY[0]"
                                formControlName="updateFrequency">
                            <label class="nsw-form__radio-label  nsw-form__required" for="updateFrequency0">{{UPDATE_FREQUENCY[0]}}</label>

                            <input 
                                class="nsw-form__radio-input" 
                                type="radio" 
                                id="updateFrequency1" 
                                name="updateFrequency"
                                [value]="UPDATE_FREQUENCY[1]"
                                formControlName="updateFrequency">
                            <label class="nsw-form__radio-label  nsw-form__required" for="updateFrequency1">Select month/s (can choose multiple)</label>
                           
                        </fieldset>
                    </div>
                    <div *ngIf="UPDATE_FREQUENCY[1] === updateFrequency?.value" formArrayName="selectedMonths">
                        <div class="nsw-form__group">                            
                            <div class="list-container nsw-m-top-sm">
                                <ng-container *ngFor="let month of updateMonths; let i = index">
                                    <input 
                                        class="nsw-form__checkbox-input" 
                                        type="checkbox" 
                                        name="form-checkbox-multi-2" 
                                        [id]="'updateFrequency-' + month"
                                        [formControlName]="i"
                                        (change)="onUpdateFreqSelectedMonthChange($event)">
                                    <label class="nsw-form__checkbox-label" 
                                        [for]="'updateFrequency-' + month">{{month}}
                                    </label>                                                      
                                </ng-container>
                            </div>

                            <span *ngIf="selecteUpdateFrequency === UPDATE_FREQUENCY[1] && selectedMonths?.touched && selectedMonths?.invalid"
                                class="nsw-form__helper nsw-form__helper--error nsw-error-msg-wrapper">
                                <span class="material-icons nsw-material-icons" focusable="false" aria-hidden="true">cancel</span>
                                Please select atleast one option
                            </span>                           
                            <div class="clear-selections">
                                <a 
                                    href="javascript:void(0)"
                                    (click)="clearAllSelectedMonths($event)"                                         
                                    role="button"
                                    class="nsw-link nsw-link--icon" >Clear all selections</a>
                                <a (click)="selectAllMonths($event)" 
                                    href="javascript:void(0)"                                        
                                    [tabindex]="0"
                                    role="button"
                                    class="nsw-link nsw-link--icon" >Select all</a>
                            </div>
                        </div>
                    </div>

                    <div class="nsw-block">                         
                        <p class="nsw-form__legend" [tabindex]="0">
                            Select the swim sites you would like to get updates for. You can choose a region or individual swim sites.
                        </p>    
                    </div>
                    <div class="nsw-form__group">
                        <app-region-council-beach-sites-selection #regionCouncilBeachSiteSelector 
                            class="region-council-beach-sites-selection"
                            [required]="true"
                            [preSelectedBeachSite]="preSelectedBeachSite"
                            [formGroup]="userSubscriptionsForm"
                            [allBeachSites]="allBeachSites"
                            [allRegions]="allRegions"
                            [allCouncils]="allCouncils">
                        </app-region-council-beach-sites-selection>
                    </div>  

                    <div class="nsw-form__group buttons-panel">
                        <button type="button" 
                            class="nsw-button nsw-button--dark-outline-solid nsw-button--full-width"
                            [disabled]="submittingForm"
                            (click)="onCancelClicked($event)">Cancel
                        </button>

                        <button type="button"
                            class="nsw-button nsw-button--dark nsw-button--full-width"
                            [disabled]="!formIsValid || submittingForm"
                            (click)="submit()">Submit
                        </button>
                    </div>
                </form>
            </div>
        </main>

    </div>

</div>
    

    


